"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MantineProvider = void 0;
var react_1 = __importDefault(require("react"));
var default_theme_1 = require("../default-theme");
var merge_theme_1 = require("../utils/merge-theme/merge-theme");
var theme_context_1 = require("./theme-context");
function MantineProvider(_a) {
    var children = _a.children, theme = _a.theme;
    return (react_1.default.createElement(theme_context_1.ThemeProvider, { theme: merge_theme_1.mergeTheme(__assign({ __mantine_theme: true }, default_theme_1.DEFAULT_THEME), theme) }, children));
}
exports.MantineProvider = MantineProvider;
MantineProvider.displayName = '@mantine/Provider';
